module.exports = __webpack_public_path__ + "img/icon-phone@3x.1ac6f1e1.png";